module.exports = __webpack_public_path__ + "images/banner-shanxi.jpg?468fc9b0352fae7b343286dd766c8d97";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-shanxi.jpg
// module id = 173
// module chunks = 1